/*!
 * CART REWARD — assets/cart-reward.js
 * Part of the Cart Reward feature.
 * Handles: progress bar animation + currency-aware discount display.
 */
(function () {
  'use strict';

  // Guard: only run once per page load
  if (window.__cartRewardLoaded) return;
  window.__cartRewardLoaded = true;

  /**
   * Format a USD amount in the customer's active Shopify currency.
   */
  function formatDiscount(usdAmount) {
    var amount   = parseFloat(usdAmount) || 0;
    var currency = 'USD';
    var rate     = 1;

    if (window.Shopify && window.Shopify.currency) {
      currency = window.Shopify.currency.active || 'USD';
      rate     = parseFloat(window.Shopify.currency.rate) || 1;
    }

    var converted = amount * rate;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(converted);
    } catch (e) {
      return currency + ' ' + Math.round(converted);
    }
  }

  /**
   * Initialise a single cart-reward widget.
   */
  function initWidget(widget) {
    if (!widget || widget.dataset.crReady === '1') return;
    widget.dataset.crReady = '1';

    // Animate progress bar
    var bar = widget.querySelector('.cart-reward__bar');
    if (bar) {
      var target = bar.dataset.targetWidth || '0%';
      setTimeout(function () { bar.style.width = target; }, 80);
    }

    // Replace [discount] placeholder with currency-formatted amount
    var discountUsd = widget.dataset.discountUsd;
    var formatted   = formatDiscount(discountUsd);
    var msgEl       = widget.querySelector('.cart-reward__message');
    if (msgEl) {
      msgEl.innerHTML = msgEl.innerHTML.replace(/\[discount\]/g, formatted);
    }
  }

  function scan() {
    initWidget(document.getElementById('cart-reward'));
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Watch for AJAX cart re-renders that inject a fresh #cart-reward
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        var widget = null;
        if (node.id === 'cart-reward') {
          widget = node;
        } else if (typeof node.querySelector === 'function') {
          widget = node.querySelector('#cart-reward');
        }
        if (widget) initWidget(widget);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
